import { render, staticRenderFns } from "./PrioridadeRegraDropdown.vue?vue&type=template&id=5317c040&scoped=true"
import script from "./PrioridadeRegraDropdown.vue?vue&type=script&lang=js"
export * from "./PrioridadeRegraDropdown.vue?vue&type=script&lang=js"
import style0 from "./PrioridadeRegraDropdown.vue?vue&type=style&index=0&id=5317c040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5317c040",
  null
  
)

export default component.exports